module.exports = __webpack_public_path__ + "img/whatsapp-plus.5cc8ec26.webp";